export enum InboundStatus {
  PENDING = 'PENDING',
  INBOUNDED = 'INBOUNDED',
}
